import { Link } from 'react-router-dom';
import { CTA, PageHero } from '../../components/Common';
import { Seo } from '../../components/Seo';
import { capabilityMap, featureGroups, integrationGroups } from '../../data/site';
import { FeatureIcon, Head, ScreenshotGallery } from './sections';

export function Features() {
  return (
    <>
      <Seo
        title="Transport software features"
        breadcrumb="Features"
        description="Trips, job cards, inventory, fuel and toll, settlements, receivables, GPS tracking, reporting, and Tally export — on desktop, in the browser, and on Android."
      />
      <PageHero
        eyebrow="Product capabilities"
        title="The working system behind your logistics operation."
        description="Every operational and financial record a transport business keeps, connected so that one entry updates the next."
      />
      <section className="section">
        <div className="container grid three">
          {featureGroups.map(f => (
            <article className="card" key={f.title}>
              <FeatureIcon name={f.icon} />
              <h2 className="card-title">{f.title}</h2>
              <p>{f.body}</p>
            </article>
          ))}
        </div>
      </section>
      <section className="section surface">
        <div className="container">
          <Head
            eyebrow="Capability map"
            title="Grouped the way the application is."
            body="The desktop workspace organises work into these areas, and the navigation follows the same shape."
          />
          <div className="grid two">
            {capabilityMap.map(group => (
              <article className="card capability" key={group.area}>
                <h3>{group.title}</h3>
                <p>{group.body}</p>
                <ul className="tick-list">
                  {group.items.map(item => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
      <ScreenshotGallery
        title="Every area, as it ships."
        body="Captured from the shipping Windows build, in the same run that produces the Microsoft Store listing."
      />
      <CTA />
    </>
  );
}

export function Integrations() {
  return (
    <>
      <Seo
        title="Fuel card, GPS, FASTag and Tally integrations"
        breadcrumb="Integrations"
        description="Google Drive, OneDrive and S3 storage, iAlert and WheelsEye tracking, BPCL and Reliance fuel cards, NETC tolls, Google Maps, and Tally."
      />
      <PageHero
        eyebrow="Integrations"
        title="Connected to the services your fleet already runs on."
        description="Transport Book talks to your tracking provider, fuel cards, bank, document storage, and accounting system. Each connection is optional and stays off until you configure it."
      />
      <section className="section">
        <div className="container grid two integration-grid">
          {integrationGroups.map(group => (
            <article className="card capability" key={group.title}>
              <h2 className="card-title">{group.title}</h2>
              <p>{group.body}</p>
              <ul className="chip-row inline">
                {group.items.map(item => (
                  <li className="chip" key={item}>
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>
      <section className="section surface">
        <div className="container prose">
          <h2>How connections are handled</h2>
          <p>
            Credentials for every integration are encrypted before they are stored on your device.
            Nothing is sent to a provider until the feature that needs it is used, and each provider
            only receives what that feature requires — a place name to geocode, a card number to
            check a balance, a file to upload.
          </p>
          <p>
            Document storage is the clearest example: attachments go to the Drive, OneDrive, or S3
            bucket <strong>you</strong> nominate, or stay on your own computers and pass directly
            between them. We never hold a copy. See the <Link to="/privacy">privacy policy</Link>{' '}
            for the full account of what each service receives.
          </p>
        </div>
      </section>
      <CTA />
    </>
  );
}
